import { axios } from '../util/axios'
import lastLoginStorage from '../util/lastLoginStorage'

const API_ENDPOINT = '/v1/accounts/my/facebook'

export const linkFacebook = facebookId =>
  axios
    .post(API_ENDPOINT, { facebookId }, { withCredentials: true })
    .then(response => {
      lastLoginStorage.saveFacebookLogin({ facebookId })
      return response
    })
    .then(response => response.status > 199 && response.status < 400)

export const unlinkFacebook = () =>
  axios
    .delete(API_ENDPOINT, {}, { withCredentials: true })
    .then(response => response.status > 199 && response.status < 400)
    .catch(e => (e.status > 399 && e.status < 500 ? false : e))
